import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getPersonnelTrainingAvailableColumns } from './api';

export const path = '/personnel-training/list';

const PagePersonnelTrainingList: React.FC = (props) => {
  const PersonnelTrainingList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getPersonnelTrainingAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <PersonnelTrainingList {...props} />;
};

export default PagePersonnelTrainingList;
